import React from "react";
import { Flex } from "../../components/ui/Flex";
import { HeaderText, SectionSubtitle } from "../../components/Modals";
import styled from "styled-components";
import { Fonts, Palette } from "../../components/utils";

export const InfoSection = ({ title, subtitle, children }) => (
  <Flex direction="column">
    <HeaderText alt>{title}</HeaderText>
    <SectionSubtitle>{subtitle}</SectionSubtitle>
    <Flex direction="column" gap="16px" style={{ marginTop: '16px' }}>
      {children}
    </Flex>
  </Flex>
);

export const UserInfo = ({ title, value, defaultValue = '-' }) => (
  <div>
    <UserInfoTitle>{title}</UserInfoTitle>
    <UserInfoText>{value || defaultValue}</UserInfoText>
  </div>
);

export const IntercomGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  ${({ withRows }) =>
    withRows &&
    `
    grid-template-rows: 1fr 1fr;
  `}

  gap: 24px 0;
  justify-content: space-around;
  align-content: space-around;
`;

const textStyles = `
  color: ${Palette.BLACK};
  font-style: normal;
  line-height: 24px;
  margin-bottom: 0;
`

export const UserInfoText = styled.p`
  ${textStyles}
  font-weight: 400;
  font-size: 16px;
`

export const UserInfoTitle = styled.p`
  ${textStyles}
  font-family: ${Fonts.RED_HAT_FONT};
  font-weight: 700;
  font-size: 18px;
`
